import {
  FabricAnnotationAnimationType,
  FabricAnnotationType,
} from './constants/index.js';
import {
  type AnnotationItem,
  type UpdateAnnotationsResult,
} from './map-operation-api/index.js';
import { setMap } from './map-set.js';

/**
 * 更新路径规划中的小车🚗配置比如行驶方向.
 */
export type FabricSetMapCarOptions = Pick<
  AnnotationItem,
  | 'id'
  | 'image'
  | 'headerDirection'
  | 'animatedImages'
  | 'coordinate'
  | 'zIndex'
>;

export type FabricSetMapCarApi = (
  options: FabricSetMapCarOptions
) => Promise<UpdateAnnotationsResult>;

/**
 * 打车路径规划中的小车配置
 */
export const setMapCar: FabricSetMapCarApi = async (
  options: FabricSetMapCarOptions
): Promise<UpdateAnnotationsResult> => {
  // 通常情况下`setMapPathPlanning`规划完成在考虑调用updateAnnotations, 设置移动小车.
  return setMap({
    type: 'updateAnnotations',
    param: {
      annotations: [
        {
          id: options.id,
          type: FabricAnnotationType.image,
          image: options.image,
          animatedImages: options.animatedImages,
          animationType: FabricAnnotationAnimationType.move,
          /**
           * 移动方向. 正北为0度，顺时针方向。即正东90，正南180，正西270,
           * 如果FabricAnnotationAnimationType.Move 的时候Native会尝试计算2个点经纬度的方向, 产生一个动画, 比如2个点之间的路径规划, 小车🚗的行驶方向.
           * 如果headerDirection存在自定义值, 则native 首先使用自定义的为准, 其次才是自动计算.
           */
          headerDirection: options.headerDirection,
          coordinate: options.coordinate,
        },
      ],
    },
  });
};
